import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/meucorreios/dialog.css';
import '../../../assets/css/meucorreios/icones-correios.css';
import permissoes from '../../../assets/img/modal-ajuda/ajuda-acesso.png';
import ajudaDados from '../../../assets/img/modal-ajuda/ajuda-dados.png';
import delegacaoAcesso from '../../../assets/img/modal-ajuda/ajuda-delegacao.png';
import dependentes from '../../../assets/img/modal-ajuda/ajuda-dependentes.png';
import ajudaEndereco from '../../../assets/img/modal-ajuda/ajuda-endereco.png';
import terceiros from '../../../assets/img/modal-ajuda/ajuda-terceiros.png';
import ajudaToken from '../../../assets/img/modal-ajuda/ajuda-token.png';
import Container from '../../../components/custom/Container';

function FormAjudaModal({ acaoCancelar }) {
  const { t } = useTranslation();
  const [formAjudaModalVisible, setFormAjudaModalVisible] = useState(true);
  const [modalDadosPessoaisVisible, setModalDadosPessoaisVisible] =
    useState(false);
  const [modalDadosEnderecosVisible, setModalDadosEnderecosVisible] =
    useState(false);
  const [modalDadosTokenVisible, setModalDadosTokenVisible] = useState(false);
  const [modalDadosPermissoesVisible, setModalDadosPermissoesVisible] =
    useState(false);
  const [modalDadosDependentesVisible, setModalDadosDependentesVisible] =
    useState(false);
  const [modalDadosDelegacaoVisible, setModalDadosDelegacaoVisible] =
    useState(false);
  const [modalDadosTerceirosVisible, setModalDadosTerceirosVisible] =
    useState(false);

  const openModalDadosPessoais = () => {
    setFormAjudaModalVisible(false);
    setModalDadosPessoaisVisible(true);
  };
  const openModalDadosEnderecos = () => {
    setModalDadosEnderecosVisible(true);
    setModalDadosPessoaisVisible(false);
  };
  const openModalDadosToken = () => {
    setModalDadosEnderecosVisible(false);
    setModalDadosTokenVisible(true);
  };
  const openModalDadosPermissoes = () => {
    setModalDadosTokenVisible(false);
    setModalDadosPermissoesVisible(true);
  };
  const openModalDadosDependentes = () => {
    setModalDadosPermissoesVisible(false);
    setModalDadosDependentesVisible(true);
  };
  const openModalDadosDelegacao = () => {
    setModalDadosDependentesVisible(false);
    setModalDadosDelegacaoVisible(true);
  };
  const openModalDadosTerceiros = () => {
    setModalDadosDelegacaoVisible(false);
    setModalDadosTerceirosVisible(true);
  };
  const closeModalDadosPessoais = () => {
    setFormAjudaModalVisible(true);
    setModalDadosPessoaisVisible(false);
  };
  const closeModalDadosEnderecos = () => {
    setModalDadosEnderecosVisible(false);
    setModalDadosPessoaisVisible(true);
  };

  const closeModalDadosToken = () => {
    setModalDadosTokenVisible(false);
    setModalDadosEnderecosVisible(true);
  };

  const closeModalDadosPermissoes = () => {
    setModalDadosTokenVisible(true);
    setModalDadosPermissoesVisible(false);
  };
  const closeModalDadosDependentes = () => {
    setModalDadosDependentesVisible(false);
    setModalDadosPermissoesVisible(true);
  };
  const closeModalDadosDelegacao = () => {
    setModalDadosDelegacaoVisible(false);
    setModalDadosDependentesVisible(true);
  };
  const closeModalDadosTerceiros = () => {
    setModalDadosDelegacaoVisible(true);
    setModalDadosTerceirosVisible(false);
  };
  const fechar = (ev) => {
    setFormAjudaModalVisible(true);
    setModalDadosPessoaisVisible(false);
    setModalDadosEnderecosVisible(false);
    setModalDadosTokenVisible(false);
    setModalDadosPermissoesVisible(false);
    setModalDadosDependentesVisible(false);
    setModalDadosDelegacaoVisible(false);
    setModalDadosTerceirosVisible(false);
    ev.preventDefault();
    acaoCancelar();
  };
  return (
    <>
      {formAjudaModalVisible && (
        <div
          id="modal-ajuda-bemvindo"
          className="dialog-container dialog-centralizado"
        >
          <div className="dialog-header">
            <h2>{t('principal.help.welcome_title')}</h2>
          </div>

          <div className="dialog-main">
            <div id="img-carol">
              <img
                alt="ilustração Carol - assistente virutal correios"
                src="/images/carol-perfil-2.png"
              />
            </div>
            <p className="t6">{t('principal.help.show_features_question')}</p>
          </div>

          <div className="dialog-footer">
            <div>
              <button
                className="btn-pre"
                autoFocus
                onClick={openModalDadosPessoais}
              >
                {t('principal.help.buttons.view_features')}
              </button>
            </div>
            <button
              className="btn-txt btn-fecha-dialog"
              onClick={(ev) => {
                ev.preventDefault();
                acaoCancelar();
              }}
            >
              {t('principal.help.buttons.dismiss')}
            </button>
          </div>
        </div>
      )}
      {modalDadosPessoaisVisible && (
        <div>
          <Container size="450">
            <div
              id="modal-ajuda-dados"
              className="dialog-container dialog-centralizado"
            >
              <div className="dialog-header com-btn-fechar">
                <div className="header-carol">
                  <div id="img-carol-p">
                    <img
                      alt="ilustração Carol - assistente virutal correios"
                      src="/images/carol-perfil.png"
                    />
                  </div>

                  <h2>{t('principal.help.personal_data.title')}</h2>
                </div>
                <button
                  className="btn-txt so-icone btn-fecha-dialog"
                  onClick={fechar}
                >
                  <i className="ic-excluir"></i>
                </button>
              </div>

              <div className="dialog-main">
                <img alt="ilustações de dados" src={ajudaDados} />

                <p className="pequeno">
                  {t('principal.help.personal_data.description1')}
                </p>

                <p className="pequeno">
                  {t('principal.help.personal_data.description2')}
                </p>
              </div>

              <div className="dialog-footer">
                <button className="btn-txt" onClick={closeModalDadosPessoais}>
                  {t('principal.help.buttons.back')}
                </button>
                <button
                  autoFocus
                  className="btn-pre"
                  onClick={openModalDadosEnderecos}
                >
                  {t('principal.help.buttons.next')}
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
      {modalDadosEnderecosVisible && (
        <div>
          <Container size="450">
            <div
              id="modal-ajuda-enderecos"
              className="dialog-container dialog-centralizado"
            >
              <div className="dialog-header com-btn-fechar">
                <div className="header-carol">
                  <div id="img-carol-p">
                    <img
                      alt="ilustração Carol - assistente virutal correios"
                      src="/images/carol-perfil.png"
                    />
                  </div>

                  <h2>{t('principal.help.addresses.title')}</h2>
                </div>

                <button
                  className="btn-txt so-icone btn-fecha-dialog"
                  onClick={fechar}
                >
                  <i className="ic-excluir"></i>
                </button>
              </div>

              <div className="dialog-main">
                <img alt="ícone de mapa" src={ajudaEndereco} />

                <p className="pequeno">
                  {t('principal.help.addresses.description1')}
                </p>

                <p className="pequeno">
                  {t('principal.help.addresses.description2')}
                </p>
              </div>

              <div className="dialog-footer">
                <button className="btn-txt" onClick={closeModalDadosEnderecos}>
                  {t('principal.help.buttons.back')}
                </button>
                <button
                  autoFocus
                  className="btn-pre"
                  onClick={openModalDadosToken}
                >
                  {t('principal.help.buttons.next')}
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
      {modalDadosTokenVisible && (
        <div>
          <Container size="450">
            <div
              id="modal-ajuda-token"
              className="dialog-container dialog-centralizado"
            >
              <div className="dialog-header com-btn-fechar">
                <div className="header-carol">
                  <div id="img-carol-p">
                    <img
                      alt="ilustração Carol - assistente virutal correios"
                      src="/images/carol-perfil.png"
                    />
                  </div>

                  <h2>{t('principal.help.token_history.title')}</h2>
                </div>

                <button
                  className="btn-txt so-icone btn-fecha-dialog"
                  onClick={fechar}
                >
                  <i className="ic-excluir"></i>
                </button>
              </div>

              <div className="dialog-main">
                <img alt="ícone de celular" src={ajudaToken} />

                <p className="pequeno">
                  {t('principal.help.token_history.description')}
                </p>
              </div>

              <div className="dialog-footer">
                <button className="btn-txt" onClick={closeModalDadosToken}>
                  {t('principal.help.buttons.back')}
                </button>
                <button
                  autoFocus
                  className="btn-pre"
                  onClick={openModalDadosPermissoes}
                >
                  {t('principal.help.buttons.next')}
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
      {modalDadosPermissoesVisible && (
        <div>
          <Container size="450">
            <div
              id="modal-ajuda-permissoes"
              className="dialog-container dialog-centralizado"
            >
              <div className="dialog-header com-btn-fechar">
                <div className="header-carol">
                  <div id="img-carol-p">
                    <img
                      alt="ilustração Carol - assistente virutal correios"
                      src="/images/carol-perfil.png"
                    />
                  </div>

                  <h2>{t('principal.help.received_permissions.title')}</h2>
                </div>

                <button
                  className="btn-txt so-icone btn-fecha-dialog"
                  onClick={fechar}
                >
                  <i className="ic-excluir"></i>
                </button>
              </div>

              <div className="dialog-main">
                <img alt="ícone de chaves" src={permissoes} />

                <p className="pequeno">
                  {t('principal.help.received_permissions.description')}
                </p>
              </div>

              <div className="dialog-footer">
                <button className="btn-txt" onClick={closeModalDadosPermissoes}>
                  {t('principal.help.buttons.back')}
                </button>
                <button
                  autoFocus
                  className="btn-pre"
                  onClick={openModalDadosDependentes}
                >
                  {t('principal.help.buttons.next')}
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
      {modalDadosDependentesVisible && (
        <div>
          <Container size="450">
            <div
              id="modal-ajuda-dependentes"
              className="dialog-container dialog-centralizado"
            >
              <div className="dialog-header com-btn-fechar">
                <div className="header-carol">
                  <div id="img-carol-p">
                    <img
                      alt="ilustração Carol - assistente virutal correios"
                      src="/images/carol-perfil.png"
                    />
                  </div>

                  <h2>{t('principal.help.dependents.title')}</h2>
                </div>

                <button
                  className="btn-txt so-icone btn-fecha-dialog"
                  onClick={fechar}
                >
                  <i className="ic-excluir"></i>
                </button>
              </div>

              <div className="dialog-main">
                <img alt="ícone de pessoas" src={dependentes} />

                <p className="pequeno">
                  {t('principal.help.dependents.description1')}
                </p>

                <p className="pequeno">
                  {t('principal.help.dependents.description2')}
                </p>
              </div>

              <div className="dialog-footer">
                <button
                  className="btn-txt"
                  onClick={closeModalDadosDependentes}
                >
                  {t('principal.help.buttons.back')}
                </button>
                <button
                  autoFocus
                  className="btn-pre"
                  onClick={openModalDadosDelegacao}
                >
                  {t('principal.help.buttons.next')}
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
      {modalDadosDelegacaoVisible && (
        <div>
          <Container size="450">
            <div
              id="modal-ajuda-delegacao"
              className="dialog-container dialog-centralizado"
            >
              <div className="dialog-header com-btn-fechar">
                <div className="header-carol">
                  <div id="img-carol-p">
                    <img
                      alt="ilustração Carol - assistente virutal correios"
                      src="/images/carol-perfil.png"
                    />
                  </div>

                  <h2>{t('principal.help.access_delegation.title')}</h2>
                </div>

                <button
                  className="btn-txt so-icone btn-fecha-dialog"
                  onClick={fechar}
                >
                  <i className="ic-excluir"></i>
                </button>
              </div>

              <div className="dialog-main">
                <img alt="ícone de perfil com um visto" src={delegacaoAcesso} />

                <p className="pequeno">
                  {t('principal.help.access_delegation.description')}
                </p>
              </div>

              <div className="dialog-footer">
                <button className="btn-txt" onClick={closeModalDadosDelegacao}>
                  {t('principal.help.buttons.back')}
                </button>
                <button
                  autoFocus
                  className="btn-pre"
                  onClick={openModalDadosTerceiros}
                >
                  {t('principal.help.buttons.next')}
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
      {modalDadosTerceirosVisible && (
        <div>
          <Container size="450">
            <div
              id="modal-ajuda-delegacao-terceiros"
              className="dialog-container dialog-centralizado"
            >
              <div className="dialog-header com-btn-fechar">
                <div className="header-carol">
                  <div id="img-carol-p">
                    <img
                      alt="ilustração Carol - assistente virutal correios"
                      src="/images/carol-perfil.png"
                    />
                  </div>

                  <h2>{t('principal.help.third_party_delegation.title')}</h2>
                </div>

                <button
                  className="btn-txt so-icone btn-fecha-dialog"
                  onClick={fechar}
                >
                  <i className="ic-excluir"></i>
                </button>
              </div>

              <div className="dialog-main">
                <img alt="ícone de perfil com um visto" src={terceiros} />

                <p className="pequeno">
                  {t('principal.help.third_party_delegation.description')}
                </p>
              </div>

              <div className="dialog-footer">
                <button className="btn-txt" onClick={closeModalDadosTerceiros}>
                  {t('principal.help.buttons.back')}
                </button>
                <button
                  autoFocus
                  className="btn-pre btn-fecha-dialog"
                  onClick={fechar}
                >
                  {t('principal.help.buttons.close')}
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
    </>
  );
}
export default FormAjudaModal;
